'use strict';

import { Operator } from '../enum/operator';

/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'OperatorRestService',
    function ($modal, OperatorRestService) {

        return {
            getDisplayName: getDisplayName,
            isBetween: isBetween,
            api: OperatorRestService,
        };

        function getDisplayName(operator) {
            let displayName = '';
            switch (operator) {
                case Operator.EQ:
                    displayName = 'Равно';
                    break;
                case Operator.NE:
                    displayName = 'Не равно';
                    break;
                case Operator.LT:
                    displayName = 'Меньше';
                    break;
                case Operator.GT:
                    displayName = 'Больше';
                    break;
                case Operator.LE:
                    displayName = 'Не больше';
                    break;
                case Operator.GE:
                    displayName = 'Не меньше';
                    break;
                case Operator.BETWEEN:
                    displayName = 'Диапазон';
                    break;
            }
            return displayName;
        }

        function isBetween(operator) {
            return operator === Operator.BETWEEN;
        }

    }];
